<template>
  <span @click="pointFn(linkProps(to || item.url || item.path))">
    <component
      :is="type"
      v-bind="{ ...linkProps(to || item.url || item.path), ...$attrs }"
    >
      <slot />
    </component>
  </span>
</template>

<script>
import { isExternal } from "@/utils/validate";
import { mapGetters } from "vuex";
import { menuParameterDisp, sentBuryPointInfo } from "@/utils/buryPoint";
import { debounce } from "lodash";
export default {
  name: "Link",
  props: {
    to: {
      type: String
    },
    toLogin: {
      type: Boolean,
      default: true
    },
    item: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(["token", "language"]),
    isExternal() {
      return isExternal(this.to || this.item.url);
    },
    type() {
      if (this.isExternal) {
        return "a";
      }
      return "router-link";
    }
  },
  methods: {
    linkProps(to) {
      if (this.isExternal) {
        let toLogin =
          (to.lastIndexOf("?") > -1 ? "&" : "?") +
          `locale=${this.language}&isIways=true&token=${this.token}`;
        if (!this.toLogin) {
          toLogin = "";
        }
        return {
          href: to + (toLogin || ""),
          target: "_blank",
          rel: "noopener"
        };
      }
      return {
        to: to && to.split(":")[0]
      };
    },
    pointFn: debounce(function(val) {
      let parameter = {};
      if (this.item) {
        parameter = {
          rsCode: `${this.item.productId || this.item.key}`,
          rsName: this.item.productName || this.item.title,
          eventContext: {
            url: "/dashboard"
          }
        };
      } else {
        parameter = menuParameterDisp(val.to || val.href);
      }
      if (parameter) {
        sentBuryPointInfo({
          ...parameter,
          eventName: `点击${this.item ? "产品" : "菜单"}`,
          eventCode: "click"
        });
      }
    }, 1000)
  }
};
</script>
